// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"24":"reset","89":"forgot","535":"login","784":"stats","908":"history","966":"dashboard"}[chunkId] + "." + {"24":"df008cf5","89":"4bb9bad9","535":"ae3d61fe","784":"4ee35480","908":"567a04cf","966":"805cf0b6"}[chunkId] + ".js";
};